<template>
  <b-card no-body>
    <!-- <b-card-header class="pb-50">
      <h5>
        Filters
      </h5>
    </b-card-header> -->
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <label class="h5">Role</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="roleFilter"
            :options="roleOptions"
            placeholder="Filter by Role"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('update:roleFilter', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <label class="h5">Level</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="levelFilter"
            :options="levelOptions"
            placeholder="Filter by Level"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('update:levelFilter', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <label class="h5">Proposed Decision</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="proposedDecisionFilter"
            :options="proposedDecisionOptions"
            placeholder="Filter by Proposed Decision"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('update:proposedDecisionFilter', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <label class="h5">Discussion</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="discussionFilter"
            :options="discussionOptions"
            placeholder="Filter by Discussion"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('update:discussionFilter', val)"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  props: {
    roleFilter: {
      type: [String, null],
      default: null,
    },
    levelFilter: {
      type: [String, null],
      default: null,
    },
    proposedDecisionFilter: {
      type: [String, null],
      default: null,
    },
    discussionFilter: {
      type: [Boolean, null],
      default: null,
    },
    roleOptions: {
      type: Array,
      required: true,
    },
    levelOptions: {
      type: Array,
      required: true,
    },
    proposedDecisionOptions: {
      type: Array,
      required: true,
    },
    discussionOptions: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
